export const codeRules = (value) => {
  if (!value) {
    return 'Campo `Código` é Obrigatório.';
  }
  return !!value.match(/^[-_A-z0-9]*$/g) || 'O Padrão é Inválido.';
};

export default codeRules;
